export const viewpointConstants = {
    VP_GETALL: 'viewpoint/getall',
    VP_CLEAR: 'viewpoint/clear',
    VP_ADD_RESOURCE: 'viewpoint/addResource',
    VP_SET_SNAPSHOTID: 'viewpoint/snapshot/post',
    VP_CLEAR_SNAPSHOT: 'viewpoint/snapshot/clear',
    VP_ADD_LOCAL_IMAGE: 'viewpoint/addLocalImage',
    VP_DELETE: 'viewpoint/delete'
};